import { TableRowCell } from './styled';
import { Grid, Box, Text } from '@simplywallst/ui-core';
import { useNormalisedCompanySnowflakeScore } from '@/hooks/useNormalisedCompanySnowflakeScore';
import { Snowflake } from '@simplywallst/ui-charts/Snowflake';
import { RouterLink } from '@redux-first-router-link';

type Score = Parameters<typeof useNormalisedCompanySnowflakeScore>[0];

type CompanyCell = {
  tickerSymbol: string | null;
  name: string | null;
  canonicalURL: string | null;
  score: Score;
};

interface Props {
  company: CompanyCell;
  isSticky?: boolean;
}

export const SymbolCell = ({ isSticky, company }: Props) => {
  const points = useNormalisedCompanySnowflakeScore(company.score);

  return (
    <TableRowCell isSticky={isSticky}>
      <Grid
        templateColumns="48px auto"
        alignItems="center"
        gap="8px"
        paddingRight="x1"
      >
        <Snowflake width={48} points={points}>
          <Snowflake.DotMarkers />
        </Snowflake>
        <Box>
          <RouterLink noUnderline to={company.canonicalURL || ''}>
            <strong>{company.tickerSymbol}</strong>
          </RouterLink>
          <Text typography="tiny" color="textSofter" lineClamp={1}>
            {company.name ?? ''}
          </Text>
        </Box>
      </Grid>
    </TableRowCell>
  );
};
